import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

/*
 * translate the value
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | modelTranslate:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({
    name: 'cdnImgSource',
    standalone: false
})
export class CdnImgSourcePipe implements PipeTransform {

  constructor() {

  }

  transform(filename?: string, folder = '', small = false): string {
    if (filename) {
      if (small) {
        const split = filename.split('.');
        return `${environment.cdn}${folder}/${split[0]}_sm.${split[1]}`;
      }
      return environment.cdn + folder + '/' + filename;
    }
    return '';
  }
}
